import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * GAPI-61892: the "Fixed text frame" control is opt-in per host (`enableTextOverflowFrames`).
 * In the embedded (buyer) editor it additionally follows the template's "Add layers"
 * switch, so a template that keeps its layers fixed does not get a new layout control.
 * Fixed frames already in a design are always applied; this only gates the control.
 */
const isTextOverflowFramesAllowed = (state: RootState) =>
  !!state.hostSettings.enableTextOverflowFrames && (!isEmbedded || isAddElementsAllowed(state));

export default isTextOverflowFramesAllowed;
